/* @ngInject */
function run ($rootScope, $http, $location) {
  $rootScope.$on('$stateChangeStart', (event, state) => {
    const isNotAuthorized = !$http.defaults.headers.common.Authorization
    const isGuestState = state.name.startsWith('guest')
    const isNotInGuestLogin = state.name !== 'guest.login' && state.name !== 'guest.resendPassword'
    const isNotPublicState = !state.public

    if (isNotAuthorized) {
      if (isGuestState && isNotInGuestLogin) {
        event.preventDefault()
        $location.path('/guest/login')
        return
      }

      if (isNotPublicState) {
        event.preventDefault()
        $location.path('/login')
      }
    }
  })
}
export const authRun = run
